function InputGeral({ width, placeholder, value, onChange, disabled = false, icon }) {
  return (
    <div
      style={{
        position: "relative",
        display: "flex",
        alignItems: "center",
        width: width,
      }}
    >
      {icon && (
        <img
          src={icon}
          alt="Ícone Pessoa"
          style={{
            position: "absolute",
            left: 10,
            height: 20,
            width: 20,
          }}
        />
      )}
      <input
        style={{
          color: "var(--cor-preto)",
          backgroundColor: "var(--cor-branco)",
          border: "1px solid var(--cor-cinzaMargin)",
          fontSize: 20,
          paddingLeft: 35,
          borderRadius: 10,
          width: "100%",
          height: 40,
        }}
        disabled={disabled}
        value={value}
        placeholder={placeholder}
        onChange={onChange}
      />
    </div>
  );
}

export default InputGeral;
